import {createAction, createAsyncAction} from 'typesafe-actions';
import {APIErrorInterface} from '../../types';
import {
    AccountDetailsData,
    AccountsListRequestPayload,
    AccountsListResponse,
    AccountTransactionsResponse,
    AddAccountPayload,
    EditAccountPayload,
    GetAccountDetailsPayload,
    GetAccountTransactionsPayload,
} from './payloads';

export const getAccountsList = createAsyncAction(
    'GET_ACCOUNTS_LIST_REQUEST',
    'GET_ACCOUNTS_LIST_SUCCESS',
    'GET_ACCOUNTS_LIST_FAILED',
)<AccountsListRequestPayload, AccountsListResponse, APIErrorInterface>();

export const addAccount = createAsyncAction(
    'ADD_ACCOUNT_REQUEST',
    'ADD_ACCOUNT_SUCCESS',
    'ADD_ACCOUNT_FAILED',
)<AddAccountPayload, void, APIErrorInterface>();

export const getAccountDetails = createAsyncAction(
    'GET_ACCOUNT_DETAILS_REQUEST',
    'GET_ACCOUNT_DETAILS_SUCCESS',
    'GET_ACCOUNT_DETAILS_FAILED',
)<GetAccountDetailsPayload, AccountDetailsData, APIErrorInterface>();

export const editAccount = createAsyncAction(
    'EDIT_ACCOUNT_REQUEST',
    'EDIT_ACCOUNT_SUCCESS',
    'EDIT_ACCOUNT_FAILED',
)<EditAccountPayload, void, APIErrorInterface>();

export const getAccountTransactions = createAsyncAction(
    'GET_ACCOUNT_TRANSACTIONS_REQUEST',
    'GET_ACCOUNT_TRANSACTIONS_SUCCESS',
    'GET_ACCOUNT_TRANSACTIONS_FAILED',
)<GetAccountTransactionsPayload, AccountTransactionsResponse, APIErrorInterface>();

export const clearAddAccountErrors = createAction(
    'CLEAR_ADD_ACCOUNT_ERRORS',
)();

export const clearEditAccountErrors = createAction(
    'CLEAR_EDIT_ACCOUNT_ERRORS',
)();
